import { a as r } from "./array-species-constructor.js";
var a = function a(_a, e) {
  return new (r(_a))(0 === e ? 0 : e);
};
export { a };